import {
  type Bundle as BundleProto,
  type BundleBaseItem as BundleBaseItemProto,
  BundleIncludedItem as BundleIncludedItemProto,
} from '@taxfyle/api-internal/internal/bundle_pb'
import { Id } from '@/infra/id'
import { safeDecimalToNumber } from '@/utils/grpc-util'
import { type BundleBaseItemProps } from './BundleBaseItem'
import { type BundleIncludedItemProps } from './BundleIncludedItem'
import { type BundleItemQuantity } from './BundleStore'

export function mapBundleBaseItemProtoToProps(
  proto: BundleBaseItemProto,
): BundleBaseItemProps {
  return {
    inventoryItemId: Id.assert(proto.getInventoryItemId()),
    inventoryItemVersionId: Id.assert(proto.getInventoryItemVersionId()),
    name: proto.getName(),
    price: safeDecimalToNumber(proto.getPrice()),
    proPrice: safeDecimalToNumber(proto.getProPrice()),
    description: proto.getDescription(),
    workspaceId: Id(proto.getWorkspaceId()?.getValue()),
    archived: proto.getArchived(),
  }
}

export function mapBundleIncludedItemProtoToProps(
  proto: BundleIncludedItemProto,
): BundleIncludedItemProps {
  return {
    inventoryItemId: Id.assert(proto.getInventoryItemId()),
    inventoryItemVersionId: Id.assert(proto.getInventoryItemVersionId()),
    name: proto.getName(),
    price: safeDecimalToNumber(proto.getPrice()),
    proPrice: safeDecimalToNumber(proto.getProPrice()),
    description: proto.getDescription(),
    workspaceId: Id(proto.getWorkspaceId()?.getValue()),
    includedQuantity: proto.getIncludedQuantity(),
    isBaseItem: false,
    archived: proto.getArchived(),
  }
}

/**
 * Maps the base item and the included items into one list, base item first.
 */
export function mapBundleProtoToIncludedItemsProps(
  proto: BundleProto,
): BundleIncludedItemProps[] {
  const baseItem = proto.getBaseItem()
  if (!baseItem) {
    return []
  }

  return [
    {
      ...mapBundleBaseItemProtoToProps(baseItem),
      includedQuantity: 1,
      isBaseItem: true,
    },
    ...proto.getIncludedItemsList().map(mapBundleIncludedItemProtoToProps),
  ]
}

export function mapBundleItemQuantityToProto(
  item: BundleItemQuantity,
): BundleIncludedItemProto {
  return new BundleIncludedItemProto()
    .setInventoryItemId(Id.assert(item.inventoryItemId))
    .setIncludedQuantity(item.includedQuantity)
}
